import { Pipe, PipeTransform } from '@angular/core';
import { Facet } from '@models/api-search.models';

/**
 * Get string of active facets keys in a group
 * possible to decide the join symbol to get the output in another format
 * default is: "string1, string2, string3"
 */
@Pipe({
    name: 'activeFacetsNames',
    standalone: true
})
export class ActiveFacetsNamesPipe implements PipeTransform {
    transform(facets?: Facet[], joinSymbol = ', ', replacers: { [search: string]: string } = {}): string {
        if (!facets?.length) {
            return '';
        }

        return facets
            .reduce((prev: (string | undefined)[], curr: Facet) => {
                if (curr.selected && curr.key) {
                    prev.push(replacers[curr.key] ? replacers[curr.key] : curr.key);
                }

                return prev;
            }, [])
            .join(joinSymbol);
    }
}
